import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Page } from '../shared';

class WinnersCardPage extends Component {
  render(){
    return (
      <Page pageClass="interview">
        <div className="page-title">
          <h1>Winner's Card</h1>
          <h3>Subheader</h3>
        </div>
        <div className="page-actions">
          <button className="button primary">Primary</button>
          <button className="button grey-button">Secondary</button>
        </div>
      </Page>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
  }
}

export default connect(mapStateToProps, {})(WinnersCardPage);



// WEBPACK FOOTER //
// ./src/components/winner/index.js